<template>
  <div class="to-chart" :style="numberChartStyle">
    <c-charts
      v-if="['line', 'bar'].includes(charType)"
      :echarts="echarts"
      :type="charType"
      :showList="showList"
      :legendShow="showLegend"
      :yAxisFormatter="yFormatter"
      :tooltipFormatter="tooltipFormatter"
      :height="height"
      :reverseXAxis="reverseXAxis"
      :emptyLabel="emptyLabel"
      ref="chart"
      :store="store"
    ></c-charts>
    <chart-map
      v-else-if="/map/.test(charType)"
      :height="700"
      :queryParam="queryParam"
      :store="store"
    ></chart-map>
    <div
      v-else-if="charType === 'pie'"
      class="pie-container"
      :style="{ height: height + 'px' }"
    >
      <div
        class="to-pie-chart"
        v-for="group in pieDataObj.store"
        :key="group.name"
      >
        <div class="group_name" v-show="group.series.length">
          {{ group.groupName }}
        </div>
        <c-pie-chart
          ref="chart"
          :echarts="echarts"
          :height="height"
          :showList="pieDataObj.showList[group.groupName]"
          :store="group.series"
        ></c-pie-chart>
      </div>
      <div
        v-if="!pieDataObj.store.length"
        class="empty-tip"
        :style="{ lineHeight: height + 'px' }"
      >
        暂无数据
      </div>
    </div>
    <div
      v-else-if="/grid/.test(charType)"
      class="to-grid"
      :style="{ height: height + 'px' }"
    >
      <whole-grid
        ref="chart"
        :show-in-panel="showInPanel"
        :meta-data="store"
        :target="target"
        :query-param="queryParam"
        :select-able="false"
      ></whole-grid>
    </div>
    <div
      v-else-if="/number/.test(charType)"
      class="to-number-chart"
      :style="{ height: height + 'px' }"
    >
      <span class="total" v-if="store.total.length">
        合计:
        <span class="value">{{ getValue(store.total[0].value) }}</span
        >{{ unit }}
      </span>

      <div class="yesterday" v-if="store.yesterDay.length">
        昨日：
        <span class="value">{{ getValue(store.yesterDay[0].value) }}</span
        >{{ unit }}
      </div>
      <div class="yesterday" v-else>
        昨日：
        <span class="value">-</span>
      </div>

      <c-tooltip :content="huanbiTip" placement="right">
        <div
          v-if="store.huanbi.length && store.huanbi[0].value !== ''"
          :class="{
            huanbi: true,
            up: store.huanbi[0].value > 0,
            down: store.huanbi[0].value < 0
          }"
        >
          环比：
          <span class="value">
            <i class="icon-arrow_glyph_up" v-if="store.huanbi[0].value > 0"></i>
            <i
              class="icon-arrow_glyph_down"
              v-if="store.huanbi[0].value < 0"
            ></i>
            {{ Math.abs(store.huanbi[0].value) }}%
          </span>
        </div>
        <div v-else class="huanbi">
          环比：
          <span class="value">
            -
          </span>
        </div>
      </c-tooltip>
      <br />
      <c-tooltip :content="tongbiTip" placement="right">
        <div
          v-if="store.tongbi.length && store.tongbi[0].value !== ''"
          :class="{
            tongbi: true,
            up: store.tongbi[0].value > 0,
            down: store.tongbi[0].value < 0
          }"
        >
          同比：
          <span class="value">
            <i class="icon-arrow_glyph_up" v-if="store.tongbi[0].value > 0"></i>
            <i
              class="icon-arrow_glyph_down"
              v-if="store.tongbi[0].value < 0"
            ></i>
            {{ Math.abs(store.tongbi[0].value) }}%
          </span>
        </div>
        <div v-else class="tongbi">
          同比：
          <span class="value">
            -
          </span>
        </div>
      </c-tooltip>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import WholeGrid from './grid'
import ChartMap from '../../components/map';
import { util } from '../../utils'
export default {
  name: 'wholeChart',
  components: { 
    WholeGrid,
    ChartMap
  },
  props: {
    charType: {
      type: String
    },
    showList: {
      type: Array,
      default () {
        return []
      }
    },
    height: {
      type: Number,
      default: 400
    },
    target: {
      default () {
        return {
          value: 'add'
        }
      }
    },
    queryParam: {
      type: Object
    },
    /**
     * @description 是否是在看板中展示
     */
    showInPanel: {
      type: Boolean,
      default: false
    },
    store: null
  },
  data () {
    return {
      echarts
    }
  },
  computed: {
    reverseXAxis () {
      let haveUserGroup = util.haveUserGroup(this.queryParam.user_group)
      return !!(
        this.charType === 'bar' &&
        ((haveUserGroup && this.queryParam.module === 'duration_avg') ||
          this.queryParam.dimension_sub)
      )
    },
    showLegend () {
      return !this.reverseXAxis
    },
    unit () {
      let unit = ''
      switch (this.queryParam.analysis_index) {
        case 'number':
          unit = '人'
          break
        case 'times':
          unit = '次'
          break
      }
      return unit
    },
    showListMap () {
      let map = {}
      this.showList.forEach(names => {
        map[names.join('-')] = true
      })
      return map
    },
    pieDataObj () {
      let store = []
      let groupMap = {}
      let haveGroup = false
      let pieShowList = {
        所有用户: []
      }
      if (this.target.value === 'duration') {
        this.store.series.forEach(series => {
          store.push({
            groupName: series.names.join('-'),
            series: this.store.x_axis.map((duration, i) => {
              return {
                names: [duration],
                values: [series.values[i]]
              }
            })
          })
        })
      } else {
        this.store.series.forEach(series => {
          if (series.names.length === 2) {
            // 认为有用户群对比
            if (this.showListMap[series.names.join('-')]) {
              let groupName = series.names[0]
              if (!pieShowList[groupName]) {
                pieShowList[groupName] = []
              }
              pieShowList[groupName].push([series.names[1]])
            }
            haveGroup = true
            if (groupMap[series.names[0]]) {
              groupMap[series.names[0]].series.push({
                names: [series.names[1]],
                values: series.values
              })
            } else {
              groupMap[series.names[0]] = {
                groupName: series.names[0],
                series: [{ names: [series.names[1]], values: series.values }]
              }
              store.push(groupMap[series.names[0]])
            }
          } else {
            pieShowList['所有用户'] = this.showList
          }
        })
        if (!haveGroup) {
          store.push({
            groupName: '所有用户',
            series: this.store.series
          })
        }
      }
      return {
        store,
        showList: pieShowList // 分组
      }
    },
    emptyLabel () {
      if (this.store.series.length && !this.showList.length) {
        return '未选中数据项'
      }
      return '暂无数据'
    },
    tongbiTip () {
      let value = ''
      if (this.store.tongbi && this.store.tongbi.length) {
        value = this.store.tongbi[0].value
      } else {
        return '-'
      }
      let date = new Date(new Date().getTime() - this.$util.dayTime * 8)
      let yesterday = new Date(new Date().getTime() - this.$util.dayTime)
      return `${this.$util.dateFormat(
        yesterday,
        'mm月dd日'
      )}和${this.$util.dateFormat(date, 'mm月dd日')}对比${
        value > 0 ? '上升' : '下降'
      }了${Math.abs(value)}%`
    },
    huanbiTip () {
      let value = ''
      if (this.store.huanbi && this.store.huanbi.length) {
        value = this.store.huanbi[0].value
      } else {
        return '-'
      }
      let yesterday = new Date(new Date().getTime() - this.$util.dayTime)
      let pre = new Date(new Date().getTime() - this.$util.dayTime * 2)
      return `${this.$util.dateFormat(
        yesterday,
        'mm月dd日'
      )}和${this.$util.dateFormat(pre, 'mm月dd日')}对比${
        value > 0 ? '上升' : '下降'
      }了${Math.abs(value)}%`
    },
    numberChartStyle () {
      return /number/.test(this.charType)
        ? {
          overflow: 'visible'
        }
        : {}
    }
  },
  methods: {
    getValue (value) {
      if (this.queryParam.module === 'duration_avg') {
        return util.timeFormat(value, 'hhhmmmsss', true)
      }
      return this.$util.toThousands(value)
    },
    yFormatter (value) {
      if (this.target.value === 'duration_avg') {
        return util.timeFormat(value, 'hhhmmmsss', true)
      } else {
        if (parseFloat(value) >= 1000) {
          return this.$util.toThousands((value / 1000).toFixed(1)) + 'k'
        } else {
          return value
        }
      }
    },
    tooltipFormatter (params) {
      let xLabel = params[0].name
      const maxLength = parseInt(
        this.$refs.chart.$el.getBoundingClientRect().width / 2 / 12
      )
      const lengthReg = new RegExp(`\\S{1,${maxLength}}`, 'g')
      if (/^\d{4}-\d{2}-\d{2}$/.test(xLabel)) {
        // 处理日期
        xLabel = xLabel.replace(/\d{4}-/, '')
      } else if (/^\d{4}-\d{2}-\d{2}\|\d{4}-\d{2}-\d{2}$/.test(xLabel)) {
        // 周、月日期
        let dates = xLabel.match(/\d{4}-\d{2}-\d{2}/g)
        xLabel =
          dates[0].replace(/\d{4}-/, '') + '~' + dates[1].replace(/\d{4}-/, '')
      } else if (/^\d{4}-\d{2}-\d{2}.(\d{2}:?){3}$/.test(xLabel)) {
        // 小时日期
        xLabel = xLabel.match(/(\d{2}:?){3}/)[0]
      } else {
        xLabel = (xLabel.match(lengthReg) || []).join('<br/>')
      }
      let seriesMap = {}
      let series = []
      params.forEach(item => {
        if (
          item.value === null ||
          item.value === undefined ||
          (seriesMap[item.seriesName] !== null &&
            seriesMap[item.seriesName] !== undefined)
        ) { return }
        seriesMap[item.seriesName] = item.value
        let value = this.$util.toThousands(item.value)
        if (this.target.value === 'duration_avg') {
          value = util.timeFormat(item.value, 'hhhmmmsss', true)
        }
        let seriesName = item.seriesName
        seriesName = (seriesName.match(lengthReg) || []).join('<br/>')
        series.push(
          `${item.marker}${seriesName}: <span style="color:#66ccff;">${value}</span>`
        )
      })

      return `<span>${xLabel}</span><br>` + series.join('<br>')
    },
    resize () {
      if (this.charType === 'pie') {
        this.$refs['chart'].forEach(chart => {
          chart.onResize()
        })
      } else {
        this.$refs.chart.onResize()
      }
    }
  }
}
</script>

<style lang="sass">
@import "styles/chart"
</style>
